
import { Link, useNavigate } from "react-router-dom";


export default function FuelExpenseTable() {
    const navigate = useNavigate();

    const handleNavigate = (vehiclenumber) => {
        navigate(`/${vehiclenumber}`);


    };
    const data = [
        { id: 1, vehiclenumber: "MH20ER4534", currentodometer: "45000", quantity: "4", amount: "$25335", date: "Mon May 12 2025" },
        { id: 2, vehiclenumber: "MH02MN0098", currentodometer: "45000", quantity: "4", amount: "$25335", date: "Mon May 12 2025" },
        { id: 3, vehiclenumber: "MH03AS3945", currentodometer: "45000", quantity: "24", amount: "$25335", date: "Mon May 12 2025" },
        { id: 4, vehiclenumber: "MH04KL0921", currentodometer: "45000", quantity: "45", amount: "$25335", date: "Mon May 12 2025" },
        { id: 5, vehiclenumber: "MH05MH5932", currentodometer: "45000", quantity: "44", amount: "$25300", date: "Mon May 12 2025" },
        { id: 6, vehiclenumber: "MH06MJ4321", currentodometer: "45000", quantity: "4", amount: "$25200", date: "Mon May 12 2025" },
        { id: 7, vehiclenumber: "MH07ND4567", currentodometer: "45000", quantity: "5", amount: "$25533", date: "Mon May 12 2025" },
        { id: 8, vehiclenumber: "MH08KK4909", currentodometer: "45000", quantity: "3", amount: "$24000", date: "Mon May 12 2025" },
        { id: 9, vehiclenumber: "MH11KL0008", currentodometer: "45000", quantity: "11", amount: "23000", date: "Mon May 12 2025" },
        { id: 10, vehiclenumber: "MH20UI3424", currentodometer: "45000", quantity: "12", amount: "25000", date: "Mon May 12 2025" },
        { id: 11, vehiclenumber: "MH20SQ9021", currentodometer: "55000", quantity: "34", amount: "26000", date: "Mon May 12 2025" },
        { id: 12, vehiclenumber: "MH23MK8245", currentodometer: "55000", quantity: "13", amount: "26543", date: "Mon May 12 2025" },
        { id: 13, vehiclenumber: "MH24NF5321", currentodometer: "55000", quantity: "55", amount: "$22422", date: "Mon May 12 2025" },
        { id: 14, vehiclenumber: "MH22PQ4441", currentodometer: "55000", quantity: "12", amount: "$25335", date: "Mon May 12 2025" },
        { id: 15, vehiclenumber: "MH12EE2323", currentodometer: "55000", quantity: "34", amount: "$25300", date: "Mon May 12 2025" },
        { id: 16, vehiclenumber: "MH11FG9090", currentodometer: "55000", quantity: "6", amount: "$25335", date: "Mon May 12 2025" },
        { id: 17, vehiclenumber: "MH20UI1221", currentodometer: "35000", quantity: "9", amount: "$25335", date: "Mon May 12 2025" },
        { id: 18, vehiclenumber: "MH20EE0890", currentodometer: "35000", quantity: "22", amount: "$25335", date: "Mon May 12 2025" },
        { id: 19, vehiclenumber: "MH20SQ0987", currentodometer: "45000", quantity: "21", amount: "$22000", date: "Mon May 12 2025" },
        { id: 20, vehiclenumber: "MH21XQ0087", currentodometer: "45000", quantity: "21", amount: "$22000", date: "Mon May 12 2025" },


    ];


    return (
        <div className="vehicle-fuel-container my-4">

            <div className="special-header panel-white-all bg-white d-flex justify-content-between align-items-center mb-2">
                <h4 className="mb-0 page-title">Vehicle Fuels</h4>
                <div className="d-flex align-items-center gap-2">
                    <Link to="/createvehiclefuel" type="button" className="btn custom-btn">Create Vehicle Fuel</Link>

                    <div className="dropdown">
                        <button id="btnGroupDropExport" type="button" className="btn custom-btn dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                            Export
                        </button>
                        <ul className="dropdown-menu" aria-labelledby="btnGroupDropExport">
                            <li><a className="dropdown-item" href="#">Save as PDF</a></li>
                            <li><a className="dropdown-item" href="#">Save as PNG</a></li>
                            <li><a className="dropdown-item" href="#">Save as CSV</a></li>
                            <li><a className="dropdown-item" href="#">Save as TXT</a></li>
                            <li><a className="dropdown-item" href="#">Save as XML</a></li>
                            <li><a className="dropdown-item" href="#">Save as SQL</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="table-top-filters d-flex flex-wrap gap-3">
               
                    <select className="form-select form-control-sm dropdrown-iteam" style={{ maxWidth: "200px" }} >
                        <option className="vehicle-dropdown">Vehicle No</option>
                        <option className="vehicle-dropdown">MH20EE3948</option>
                        <option className="vehicle-dropdown">MH21RE4890</option>
                    </select>
                
                    <input type="text" className="form-control form-control-sm" placeholder="Enter Odometer Riding" style={{ maxWidth: "200px" }}/>
                   <button type="button" class="btn custom-btn">Clear</button>

            </div>


            <div className="card-body ">

                <div className="table-responsive">
                    <table className="custom-table">
                        <thead>

                            <tr>
                                <th>Sr No</th>
                                <th>Vehicle Number</th>
                                <th>Current Odometer</th>
                                <th>Quantity</th>
                                <th>Ammount</th>
                                <th>Date</th>
                                <th>Action</th>

                            </tr>

                        </thead>
                        <tbody>
                            {data.map((row) => (
                                <tr key={row.id}>
                                    <td>{row.id}</td>
                                    <td>{row.vehiclenumber}</td>
                                    <td>{row.currentodometer}</td>
                                    <td>{row.quantity}</td>
                                    <td>{row.amount}</td>
                                    <td>{row.date}</td>
                                    <td>
                                        <div className="btn-group">
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.vehiclenumber)}
                                                title="View">
                                                <i class="bi bi-eye"></i>
                                            </button>
                                            <Link to="/updatevehiclefuel"
                                                type="button"
                                                className="btn  btn-sm"
                                                title="Edit">
                                                <i className="bi bi-pencil-square"></i>
                                            </Link>
                                            <button
                                                type="button"
                                                className="btn  btn-sm"
                                                onClick={() => handleNavigate(row.categoryname)}
                                                title="Delete">
                                                <i className="bi bi-trash3"></i>
                                            </button>
                                        </div>

                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>




    );
}
